import React , {Component} from 'react';
import skill from './data/skills'
const Skills = (props) =>{
    return( 
      <div className="skill-card"  onclick="void(0)" >
      <header className="skill-card__header" style={{backgroundColor: `${props.bg}`}}><img className="skill-card__icon" src={`${props.iconLink}`} alt={props.alt}/></header>
      <section className="skill-card__body">
    <h2 className="skill-card__title">{props.name}</h2><span className="skill-card__duration">EXPERIENCE</span>
        <ul className="skill-card__knowledge">
    <li>{props.name}</li>
          <li><div className="SkillBarContainer">
  <div className="skills" style={{ backgroundColor : `${props.bg}`, width : `${props.width}` }}>
{props.percent}
  </div>
</div></li>
        </ul>
      </section>
    </div>

    )
}

export default class SkillsComponent extends Component {

    render() {
      return (   
  <div className="SkillsContainer" id='Skills'>
      <h1>Technologies <span className='white'> I'm</span> <br/> skilled in<span className='white'>...</span></h1>
      <div className='SkillShowCase'>
      {
          skill.map((skill , index) => {
            return <Skills name={skill.name} bg={skill.bg} iconLink={skill.iconLink} alt={skill.alt} width= {skill.width} percent={skill.percent} key={index} />
          })
      }
      </div>
      
  </div>

      )
    }
  }
